import { render } from "./Score_Client.vue?vue&type=template&id=319f8562"
import script from "./Score_Client.vue?vue&type=script&lang=js"
export * from "./Score_Client.vue?vue&type=script&lang=js"

import "./Score_Client.vue?vue&type=style&index=0&id=319f8562&lang=css"

import exportComponent from "C:\\projeto\\dynamik\\dynamik_webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__